const DEFAULT_LOCALE = 'en-US';
const DEFAULT_LOCALE_FALLBACKS = {
	'en': 'en-US',
	'es': 'en-ES',
	'zh': 'zh-CN',
	'zh-HK': 'zh-TW',
	'zh-TW': 'zh-HK',
	'zh-MO': 'zh-HK',
	'fr': 'fr-FR',
	'de': 'de-DE',
	'it': 'it-IT',
	'ru': 'ru-RU',
	'ja': 'ja-JP'
};

export { DEFAULT_LOCALE, DEFAULT_LOCALE_FALLBACKS };
